/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Stats_Scope_PurchaseInputs */

const vi_warehouse_stats_scope_purchase = /** @type {(inputs: Warehouse_Stats_Scope_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chè thu mua`)
};

/**

* @param {Warehouse_Stats_Scope_PurchaseInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_stats_scope_purchase = /** @type {((inputs?: Warehouse_Stats_Scope_PurchaseInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Stats_Scope_PurchaseInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_stats_scope_purchase(inputs)
});